<template>
  <v-container fluid class="employeeface-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Employee Face</v-stepper-step>
              <v-divider></v-divider>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Create Employee Face</p>
                        <v-select
                          class="mb-4"
                          :items="employees.filter(x=>x.employeestatus=='Active').map(x => {return {text: x.employeename, value: x._id};})"
                          v-model="employeeface.employeeid"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Employee"
                          persistent-hint
                          single-line hint="Please choose the employee">
                        </v-select>
                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <div class="d-flex justify-end">

                        </div>
                        <div class="d-flex justify-center">
                          <v-btn
                              to="/employeeface/list"
                              replace
                              outlined
                              color="primary"
                          >
                            Cancel
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            :disabled="employeeface.encodings.length === 0 || employeeface.encodings == null"
                            class="button-shadow"
                            color="primary"
                            @click="createEmployeeFace()">
                            Save
                          </v-btn>
                        </div>

                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';
import axios from "axios";

export default {
  data () {
    return {
      step: 1,
      imageurl: undefined,
      employeeface: {
        employeeid: null,
        encodings: []
      },
      items: ['Full Time', 'Part Time', 'Contract'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },

  methods: {
    ...mapActions('EmployeeFace', ['createEmployeeFaceRequest','getEmployeeFacesRequest']),
    ...mapActions('Employee', ['getEmployeesRequest']),
    checkError(){
      //if(this.employeeface.employeefacecode.length>0) {this.step=2; return true;}
      if(!this.employeeface.employeefacecode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.employeeface.employeefacename){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.employeeface.employeefacetitle){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.employeeface.employeefacepin || this.employeeface.employeefacepin.length<6 ){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      if(!this.employeeface.employeefacetype){
        this.haserrors = true;
        this.errorindex = 4;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    createEmployeeFace() {
      console.log(this.employeeface)
      this.createEmployeeFaceRequest(this.employeeface)
      //this.getEmployeeFacesRequest()
      router.push('/employeeface/list')
    },

    onFileChange(file) {
      if (!file) {return;}
      this.employeeface.employeefaceimage = file;
      this.employeeface.imagename = file.name;
      const reader = new FileReader();
      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
      this.getEmployeeFaceEncodings(this.employeeface)
    },
    getEmployeeFaceEncodings(payload) {
      console.log(payload)
      let url = 'https://chatxc.com/py/face/get/encoding';
      let data = new FormData();
      data.append('file', payload.employeefaceimage, payload.imagename); 
      for (let x in payload) {
        data.append(x, payload[x]);
      }

      var headers = {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'bP02#J#giCr0p5RUsW$-*cRlZ&+hUW$10b+N8$8_#=7?93E0r2yiNA2Lra*iB@Ami',
      };
      axios({method: "post", url: url, headers: headers, data: data})
      .then(res => {
        console.log(res.data);
        this.employeeface.encodings = res.data.encoding;
      })
    },
  },
  mounted () {
    if(this.employees.length==0) this.getEmployeesRequest();
  },
  computed: {
    ...mapState('EmployeeFace', ['isReceiving']),
    ...mapState('Employee', ['employees']),
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
